module.exports = __webpack_public_path__ + "static/media/somaiyalogo.fc66ca02.png";